module.exports = __webpack_public_path__ + "img/imgZXGH(7).b27b1dd4.png";